import React, { createContext, useState, ReactNode, useContext, useEffect } from 'react';
import configService  from '../api/configService';

interface CentralizeStoreProps {
  setSearchRes?: React.Dispatch<React.SetStateAction<any[]>>;
  setSearchedText?: React.Dispatch<React.SetStateAction<string>>
  setUploadedImage?: React.Dispatch<React.SetStateAction<string | null>>;
  searchRes?: any[];
  searchedText?: string
  uploadedImage ? : string | null
  setIsSuperAdminExist ? : React.Dispatch<React.SetStateAction<boolean>>
  isSuperAdminExist ? : boolean
  setTagSearchData ?: React.Dispatch<React.SetStateAction<any>>;
  tagSearchData ?: any;
  setIsFilteredExist ?: React.Dispatch<React.SetStateAction<boolean>>;
  isFilteredExist ?: boolean,
  IsFilteredExistTrue ? : any,
  IsFilteredExistFalse ? : any,
  setSearchTagFormState ? : React.Dispatch<React.SetStateAction<any>>;
  searchTagFormState ? : any;
  setFilterState ? :  React.Dispatch<React.SetStateAction<any>>;
  filterState ? : any;
  setIsTagSearch ? : React.Dispatch<React.SetStateAction<boolean>>;
  isTagSearch ?: boolean;
  setIsSearchLoading ?: React.Dispatch<React.SetStateAction<boolean>>;
  isSearchLoading ?: boolean;
  setIsUploading ?: React.Dispatch<React.SetStateAction<boolean>>;
  isUploading ?: boolean;
  setParentPath?: React.Dispatch<React.SetStateAction<string>>
  parentPath?: string
  setParentPathId?: React.Dispatch<React.SetStateAction<string>>
  parentPathId?: string;
  setDomainByAI?: React.Dispatch<React.SetStateAction<boolean>>;
  domainByAI?: boolean;
  setFeatureGenerateTag?: React.Dispatch<React.SetStateAction<boolean>>;
  featureGenerateTag?: boolean;
  setFeatureSearch?: React.Dispatch<React.SetStateAction<boolean>>;
  featureSearch?: boolean;
  setConfigSettings?: React.Dispatch<React.SetStateAction<string>>
  configSettings?: string
  resetCentralizeStore?: () => void;
}

const defaultContextValue: CentralizeStoreProps = {
  setSearchRes: () => {},
  setSearchedText: () => {},
  setUploadedImage: () => {},
  searchRes: [],
  searchedText : '',
  uploadedImage : null,
  setIsSuperAdminExist : () => {},
  isSuperAdminExist : false,
  setTagSearchData: () => {},
  tagSearchData : {},
  setIsFilteredExist: () => {},
  isFilteredExist : null,
  IsFilteredExistTrue : () => {},
  IsFilteredExistFalse : () => {},
  setSearchTagFormState : () => {},
  searchTagFormState : {},
  setFilterState : () => {},
  filterState : {},
  setIsTagSearch: () => {},
  isTagSearch : null,
  setIsSearchLoading: () => {},
  isSearchLoading : null,
  setIsUploading : () => {},
  isUploading : false,
  setParentPath: () => {},
  parentPath : '/root',
  setParentPathId: () => {},
  parentPathId : '/root',
  setDomainByAI: () => {},
  domainByAI: false,
  setFeatureGenerateTag: () => {},
  featureGenerateTag: false,
  setFeatureSearch: () => {},
  featureSearch: false,
  resetCentralizeStore: () => {},

};

export const CentralizeStore = createContext<CentralizeStoreProps>(defaultContextValue);

interface CentralizeStoreProviderProps {
  children: ReactNode;
}

export const CentralizeStoreProvider = ({ children }: CentralizeStoreProviderProps) => {
  const [searchRes, setSearchRes] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [tagSearchData, setTagSearchData] = useState({})
  const [isTagSearch, setIsTagSearch] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [parentPath, setParentPath] = useState("root");
  const [parentPathId, setParentPathId] = useState("root");
  const [isSuperAdminExist, setIsSuperAdminExist] = useState(() => {
    const role = localStorage.getItem("role");
    return role === "superAdmin";
  });
  const [isFilteredExist, setIsFilteredExist] = useState(false);
  const [filterState, setFilterState] = useState({
    fromDate: "",
    toDate: "",
    selectedDomains: [],
    selectedScopes: [],
    selectedStatus: []
  });

  const [searchTagFormState, setSearchTagFormState] = useState({
    selectedDomain: '',
    selectedCategory: '',
    attributes: {},
    selectedAttributes: {},
    selectMatchType: ''
  });
  const [isUploading, setIsUploading] = useState(false)
  const [domainByAI, setDomainByAI] = useState(false);
  const [featureGenerateTag, setFeatureGenerateTag] = useState(true);
  const [featureSearch, setFeatureSearch] = useState(true);
  const comp_id = localStorage.getItem("comp_id");
  const [configSettings, setConfigSettings] = useState(null);


  useEffect(() => {
    const role = localStorage.getItem("role");
    setIsSuperAdminExist(role === "superAdmin");
  }, []);

	useEffect(() => {
		handleFetchLatestConfigSetting();
		}, []);

	const handleFetchLatestConfigSetting = async () => {
		  try{
			const response = await configService.getFeatureConfig(comp_id);
        let featureList = response.configuration_data;
        setFeatureGenerateTag(featureList.Intelli_Tag);
        setFeatureSearch(featureList.Intelli_Search);
        setDomainByAI(featureList.Domain_by_AI);
        setConfigSettings(response);
		  }catch(err){
			console.log("err while getting config setting: ", err)
		  }
		}



  const IsFilteredExistTrue =() =>  {
     setIsFilteredExist(true)
  }
  const IsFilteredExistFalse = () => {
    setIsFilteredExist(false)
  }

  // This provider is mounted once at the app root (src/index.tsx), above the
  // router - it never remounts across a logout/login cycle, so nothing here
  // resets itself just because a different user (or the same user again)
  // logs in. Logout (Layout.tsx's signOut) clears localStorage/sessionStorage
  // but that's a different store - without this, state like parentPathId
  // (which folder you last drilled into) would silently carry over into the
  // next login, regardless of user/company. Call this from every logout path.
  const resetCentralizeStore = () => {
    setSearchRes([]);
    setSearchedText("");
    setUploadedImage(null);
    setTagSearchData({});
    setIsTagSearch(false);
    setIsSearchLoading(false);
    setParentPath("root");
    setParentPathId("root");
    setIsSuperAdminExist(false);
    setIsFilteredExist(false);
    setFilterState({
      fromDate: "",
      toDate: "",
      selectedDomains: [],
      selectedScopes: [],
      selectedStatus: []
    });
    setSearchTagFormState({
      selectedDomain: '',
      selectedCategory: '',
      attributes: {},
      selectedAttributes: {},
      selectMatchType: ''
    });
    setIsUploading(false);
    setDomainByAI(false);
    setFeatureGenerateTag(true);
    setFeatureSearch(true);
    setConfigSettings(null);
  };

  return (
    <CentralizeStore.Provider value={{ setSearchRes, searchRes, setSearchedText, searchedText, setUploadedImage, uploadedImage, setIsSuperAdminExist, isSuperAdminExist, setTagSearchData, tagSearchData,setIsFilteredExist,isFilteredExist,IsFilteredExistTrue,IsFilteredExistFalse,setSearchTagFormState,searchTagFormState,setFilterState, filterState, setIsTagSearch,isTagSearch,setIsSearchLoading, isSearchLoading, isUploading, setIsUploading, setParentPath, parentPath, parentPathId, setParentPathId, setDomainByAI, domainByAI, setFeatureSearch, featureSearch, setFeatureGenerateTag, featureGenerateTag, configSettings,setConfigSettings, resetCentralizeStore, }}>
      {children}
    </CentralizeStore.Provider>
  );
};